import callApi from 'utils/callApi';

// Requests
export function requestSearchCheckNumbers(payload) {
  return callApi('resource/check_book_sheet/search/', 'POST', payload);
}

export function requestFetchCheckNumbers({ limit, offset }) {
  return callApi(`resource/check_book_sheet/?limit=${limit}&offset=${offset}`);
}



// WEBPACK FOOTER //
// ./src/redux/modules/checkNumbers.js